import React from "react";
import useGameStore from "../store/gameStore";

function GameOver() {
  const score = useGameStore((s) => s.score);
  const retry = useGameStore((s) => s.retry);
  const goHome = useGameStore((s) => s.goHome);

  return (
    <div
      style={{
        zIndex: "5",
        width: "295px",
        height: "295px",
        borderRadius: "45px",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Jua, sans-serif",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <div
        style={{
          margin: "auto",
          marginTop: "15px",
          height: "100%",
          width: "100%",
          backgroundColor: "#2F2F2F",
          borderRadius: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "white", margin: "0 0 4px 0" }}>FINAL SCORE</h2>
        <span
          style={{ color: "lightgray", fontSize: "24px", margin: "0 0 12px 0" }}
        >
          {score}
        </span>
        <button
          onClick={retry}
          style={{
            fontFamily: "Jua, sans-serif",
            fontSize: "22px",
            padding: "6px 28px",
            backgroundColor: "#2F2F2F",
            borderRadius: "25px",
            border: "3px solid #8ade63",
            cursor: "pointer",
            color: "#8ade63",
            margin: "4px",
          }}
        >
          try again
        </button>
        <button
          onClick={goHome}
          style={{
            fontFamily: "Jua, sans-serif",
            fontSize: "22px",
            padding: "6px 46px",
            backgroundColor: "#2F2F2F",
            borderRadius: "25px",
            border: "3px solid #676767",
            cursor: "pointer",
            color: "#676767",
            margin: "4px",
          }}
        >
          home
        </button>
      </div>
    </div>
  );
}

export default GameOver;
